import type { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { showError } from './toastSlice';

// Статусы которые НЕ показываем как глобальную ошибку
// (401 — обрабатывается через редирект на логин, 404 — штатная ситуация)
const IGNORED_STATUSES = [401, 403, 404];

export const errorMiddleware: Middleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const status = (action.payload as any)?.status;

    if (!IGNORED_STATUSES.includes(status)) {
      store.dispatch(showError('Ой-ой, что-то пошло не так'));
    }
  }

  return next(action);
};
